import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isNodeOrCaptionSelected = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  const isCaption = editor?.state?.selection.$anchor.parent.type.name === Node_Type.CAPTION || editor?.state?.selection.$head.parent.type.name === Node_Type.CAPTION;
  return !!node || isCaption;
});
export {
  isNodeOrCaptionSelected
};
//# sourceMappingURL=is-node-or-caption-selected.js.map
